import { EnvContextShape } from '../../../context/env';

export function getLanguageSubdirectorySubPath(
    envContext: Partial<EnvContextShape>,
): string {
    return envContext?.env?.localeInfo?.uses_language_subdirectory &&
        envContext?.env?.localeInfo?.locale
        ? `/${envContext.env.localeInfo.locale}`
        : '';
}
